import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EnquiryList from "../components/Enquiry/EnquiryList";


const EnquiryListPage = () => {
  return (
    <>
    
        {/* Breadcrumb */}
        {/* <Breadcrumb title="Add Subscription" /> */}
        <div className="d-flex justify-content-between"><h5>Enquiry </h5><Breadcrumb title="Enquiries" /></div>
        {/* AddUserLayer */}
        <EnquiryList />


    
    </>
  );
};

export default EnquiryListPage;
